/**
 * searchArticles — 文章推荐工具
 *
 * 根据参数搜索精选/标签文章，返回格式化后的 Markdown 链接列表。
 */

import { getArticleList } from '@/service/article';

/** 文章搜索参数 */
export interface ArticleSearchParams {
  pageSize?: number;
  isFeatured?: string;
  tag?: string;
}

/**
 * 搜索文章并返回格式化结果
 * @param params 搜索参数
 * @returns Markdown 格式的文章链接列表，如 "1. [标题](url) — 摘要"
 */
export async function searchArticles(params: ArticleSearchParams = {}): Promise<string> {
  try {
    const mergedParams: Record<string, unknown> = { page: 1, ...params };
    const res = await getArticleList(mergedParams);
    if (res?.success && res.data?.list?.length) {
      const baseUrl = 'https://www.adai.org.cn';
      return res.data.list
        .map(
          (a, i) =>
            `[${a.title}](${baseUrl}/blog/article/${a.postsId})}`,
        )
        .join('\n');
    }
    return '';
  } catch {
    return '';
  }
}
